import { XTinyMCE } from '@adornis/writer/x-tinymce.js';
import { customElement, property } from 'lit/decorators.js';
import type { EditorOptions } from 'tinymce';

@customElement('ils-tinymce')
export class ILSTinyMCE extends XTinyMCE {
  @property() override editorOptions = {
    toolbar:
      'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | sizeselect | fontselect |  fontsizeselect | alignleft aligncenter alignright alignjustify | outdent indent lineheight |  numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen | image media link codesample | table tablemergecells',
    toolbar_mode: 'wrap',
    menubar: false,
    contextmenu: [],
    quickbars_insert_toolbar: false,
    quickbars_selection_toolbar: false,
    elementpath: false,
    language: 'de',
  } as Partial<EditorOptions>;
}
